<template>
    <div class="user-section-div">
        <div class="user-sub-section badge-div">
            <Messages />
            <TicketAlertsControl />
        </div>
        <div class="d-none d-md-inline-block user-sub-section">
            <div class="app-bar-user-name">
                {{ user.name }}
            </div>
            <div class="app-bar-user-role">
                {{ user.ingroup }}
            </div>
        </div>
        <div class="user-sub-section">
            <v-menu
                v-model="showUserProfileMenu"
                bottom
                left
                :offset-y="true"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-avatar
                            class="appbar-avatar"
                            :class="avatarRingClass"
                        >
                            <v-icon
                                color="linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), #122448"
                                style="height: 40px; width: 40px;"
                            >
                                person
                            </v-icon>
                        </v-avatar>
                    </v-btn>
                    <v-icon>
                        expand_more
                    </v-icon>
                </template>
                <v-list
                    width="260px"
                >
                    <v-list-item>
                        <CachingOfflineDataProgress v-if="cachingOfflineData" />
                        <OnlineStatus 
                            v-else
                            @going-offline="goOffline"
                            @going-online="goOnline"
                        />
                    </v-list-item>
                    <v-divider />
                    <router-link
                        to="/profile"
                        :class="offline ? 'disabled-router-link' : ''"
                    >
                        <v-list-item 
                            :disabled="offline"
                            @click="doNothing"
                        >
                            <v-list-item-icon>
                                <v-icon
                                    :disabled="offline"
                                >
                                    settings
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Profile Settings</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <v-divider />
                    <router-link 
                        to="/"
                        :class="offline ? 'disabled-router-link' : ''"
                    >
                        <v-list-item 
                            :disabled="offline"
                            @click="signout"
                        >
                            <v-list-item-icon>
                                <v-icon 
                                    :disabled="offline"
                                    color="red"
                                >
                                    logout
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Sign Out
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                    <v-list-item class="version-item" dense>
                        <v-list-item-content class="version-content">
                            <v-list-item-subtitle class="version-text">
                                Version {{ appVersion }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </div>
</template>
<script>
import MessagesIndex from './Messages/';
import ticketAlertsIndex from './TicketAlerts/';
import OnlineStatus from '@/components/OnlineStatus';
import CachingOfflineDataProgress from './CachingOfflineDataProgress';
import { deleteAuthCookie } from '../utils/cookie';
import pkg from '../../package.json';

export default {
    name: 'AppBarUserMenu',
    components: {
        Messages: MessagesIndex?.Messages,
        TicketAlertsControl: ticketAlertsIndex?.TicketAlertsControl,
        OnlineStatus,
        CachingOfflineDataProgress,
    },
    data() {
        return {
            ticketAlerts: [],
            invisible: 'rbga(0,0,0,0)',
            showUserProfileMenu: false,
            offlineStatusInterval: null,
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        cachingOfflineData() {
            return this.$store.getters.cachingOfflineData;
        },
        avatarRingClass() {
            if(this.$store.getters.forceOffline) {
                return 'offline';
            }
            if(this.$store.getters.lostInternet) {
                return 'no-connection';
            }
            return 'online';
        },
        offline() {
            return this.$store.getters.forceOffline;
        },
        appVersion() {
            return pkg.version;
        }
    },
    methods: {
        doNothing() {
            // this method does nothing
            // it is used to style the list items in the user sub section drop down
        },
        async signout() {
            if(!this.offline) {
                // we need only delete the cookie because the router-link will take us back to the sign in page
                await deleteAuthCookie();
                this.$store.commit('SET_TAB_SELECTED_ITEMS', {});
                // Remove all saved data from sessionStorage
                // sessionStorage.clear();
            }
        },
        goOffline() {
            // set interval check status
            // when status changes wait briefly before closing menu
            this.offlineStatusInterval = setInterval(() => {
                if(this.$store.getters.forceOffline) {
                    this.clearOfflineStatusInterval();
                    this.$router.push('/offline/tickets');
                    setTimeout(() => {
                        this.showUserProfileMenu = false;
                    }, 1500);
                }
            }, 100);
        },
        goOnline() {
            // set interval check status
            // when status changes wait briefly before closing menu
            this.offlineStatusInterval = setInterval(() => {
                if(!this.$store.getters.forceOffline) {
                    this.clearOfflineStatusInterval();
                    this.$router.push('/tickets');
                    setTimeout(() => {
                        this.showUserProfileMenu = false;
                    }, 500);
                }
            }, 10);                
        },
        clearOfflineStatusInterval() {
            clearInterval(this.offlineStatusInterval);
            this.offlineStatusInterval = null;
        }
    },
};
</script>
<style scoped>
.hidden-badge {
    visibility: hidden;
}
.user-section-div {
    height:inherit;
}
.user-sub-section {
    display: inline-block;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    line-height: 100%;
    margin-right: 20px;
}
.appbar-avatar .v-icon {
    background-color: #F0F6FF;
    border-width: 2px;
    border-style: solid;
}
.appbar-avatar.online .v-icon {
    border-color: #2FA84F;
}
.appbar-avatar.offline .v-icon {
    border-color: #F3A72E;
}
.appbar-avatar.no-connection .v-icon {
    border-color: #CB3D31;
}
.app-bar-user-name {
    color: #122448;
    font-size:14px;
    font-weight: 500;
    text-align: right;
}
.app-bar-user-role {
    color: #7F8592;
    font-size:12px;
    font-weight: 400;
    text-align: right;
}
#user-status-menu-text {
    color: #02C386
}
.disabled-router-link {
    cursor: default;
}
a {
    text-decoration: none;
}
.version-item {
    min-height: 16px;
    padding-top: 0;
    padding-bottom: 0;
    pointer-events: none;
}
.version-content {
    margin: 0;
    padding: 0;
}
.version-text {
    color: #7F8592;
    font-size: 11px;
    line-height: 1.1;
    margin: 0;
    padding: 0;
    text-align: right;
}
</style>
